import { createContext, useState, useRef } from 'react';
import __isUndefined from 'lodash/isUndefined';

export const GlobalVarsContext = createContext();

const GlobalVarsProvider = (props) => {
    const { children } = props;
    const [globalVars, setGlobalVars] = useState({});
    const eventsRef = useRef({});
    const emittedHistoryRef = useRef({});

    const getGlobalVar = (key) => {
        return globalVars[key];
    };
    const setGlobalVar = (key, value) => {
        const globalVar = {};
        globalVar[key] = value;
        setGlobalVars({ ...globalVars, ...globalVar });
    };

    const resetGlobalVar = (key) => {
        delete globalVars[key];
        setGlobalVars({ ...globalVars });
    };

    const onEmitter = (event, componentId, callback) => {
        if (!eventsRef.current[event]) {
            eventsRef.current[event] = new Map();
        }
        if (!eventsRef.current[event].has(componentId)) {
            eventsRef.current[event].set(componentId, callback);

            if (!__isUndefined(emittedHistoryRef.current[event])) {
                callback(emittedHistoryRef.current[event]);
            }
        }
    };

    const offEmitter = (componentId) => {
        if (!eventsRef.current) return;
        Object.keys(eventsRef.current).forEach((event) => {
            eventsRef.current[event]?.delete(componentId);
            if (eventsRef.current[event]?.size === 0) {
                delete eventsRef.current[event];
            }
        });
    };

    const emit = (event, data) => {
        emittedHistoryRef.current[event] = data;
        if (!eventsRef.current[event]) return;
        eventsRef.current[event].forEach((cb) => cb(data));
    };

    return (
        <GlobalVarsContext.Provider
            value={{
                getGlobalVar,
                setGlobalVar,
                resetGlobalVar,
                onEmitter,
                offEmitter,
                emit
            }}
            children={children}
        />
    );
};

export default GlobalVarsProvider;
